<div *ngIf="!!passwordToCheck" id="strength" #strength [title]="title" class="strengthWrapper">
  <p>{{title}}</p>
  <ul id="strengthBar" class="strengthBar" aria-hidden="true">
    <li id="bar0" class="point" [style.background-color]="bar0"></li>
    <li class="point" [style.background-color]="bar1"></li>
    <li class="point" [style.background-color]="bar2"></li>
    <li class="point" [style.background-color]="bar3"></li>
    <li class="point" [style.background-color]="bar4"></li>
  </ul>
</div>
